import { formatNomPropre, formatNAS } from '../utils/formatters';
import DateInput from './DateInput';

const NouveauModal = ({ showNouveauModal, setShowNouveauModal, nouveauForm, setNouveauForm, handleNouveauSearch, isSearchingDuplicates, showDuplicateList, setShowDuplicateList, duplicateClients, handleSelectExistingClient, handleCreateNewAnyway }) => {
  if (!showNouveauModal) return null;
  
  return (
    <div className="popup-overlay">
      <div className="nouveau-modal" onClick={e => e.stopPropagation()}>
        <div className="popup-header" style={{ background: '#0033A0' }}>
          <span className="popup-title">Nouveau Dossier - Identification</span>
          <button className="win-modal-close" onClick={() => setShowNouveauModal(false)}>{'×'}</button>
        </div>
        
        {!showDuplicateList ? (
          <div className="nouveau-modal-content">
            <p className="nouveau-modal-instruction">
              Veuillez entrer les informations d'identification du requérant pour vérifier s'il existe déjà dans la base de données.
            </p>
            <div className="nouveau-form-grid">
              <div className="win-field">
                <label className="win-field-label required">Nom *</label>
                <input className="win-input" value={nouveauForm.nom} onChange={e => setNouveauForm({...nouveauForm, nom: formatNomPropre(e.target.value)})} placeholder="Nom de famille" maxLength={40} data-testid="nouveau-nom" autoFocus />
              </div>
              <div className="win-field">
                <label className="win-field-label required">Prénom *</label>
                <input className="win-input" value={nouveauForm.prenom} onChange={e => setNouveauForm({...nouveauForm, prenom: formatNomPropre(e.target.value)})} placeholder="Prénom" maxLength={40} data-testid="nouveau-prenom" />
              </div>
              <div className="win-field">
                <label className="win-field-label required">Date de naissance *</label>
                <DateInput value={nouveauForm.date_naissance} onChange={v => setNouveauForm({...nouveauForm, date_naissance: v})} testId="nouveau-date-naissance" />
              </div>
              <div className="win-field">
                <label className="win-field-label">N.A.S. (optionnel)</label>
                <input className="win-input" value={nouveauForm.nas} onChange={e => setNouveauForm({...nouveauForm, nas: formatNAS(e.target.value)})} placeholder="000-000-000" maxLength={11} data-testid="nouveau-nas" />
              </div>
            </div>
            <div className="nouveau-modal-actions">
              <button className="win-btn-action" onClick={handleNouveauSearch} disabled={isSearchingDuplicates} data-testid="nouveau-continuer">
                {isSearchingDuplicates ? 'Recherche...' : 'Continuer'}
              </button>
              <button className="win-btn-action win-btn-secondary" onClick={() => setShowNouveauModal(false)}>Annuler</button>
            </div>
          </div>
        ) : (
          <div className="nouveau-modal-content">
            <p className="nouveau-modal-warning">
              {duplicateClients.length} client(s) existant(s) trouvé(s) avec ces informations :
            </p>
            <div className="duplicate-list">
              {duplicateClients.map((client, index) => (
                <div key={client.id || index} className="duplicate-item">
                  <div className="duplicate-info">
                    <strong>{client.prenom} {client.nom}</strong>
                    <span>Né(e) le : {client.date_naissance || 'N/A'}</span>
                    {client.nas && <span>NAS: {client.nas}</span>}
                    <span>Adresse : {[client.adresse, client.ville, client.province, client.code_postal].filter(Boolean).join(', ') || '— aucune —'}</span>
                    {(client.telephone_residence || client.telephone_bureau || client.cellulaire) && (
                      <span>Tél. : {[client.telephone_residence, client.telephone_bureau, client.cellulaire].filter(Boolean).join(' / ')}</span>
                    )}
                    {client.derniere_demande && <span>Dernière demande : {client.derniere_demande}</span>}
                    <span className="duplicate-id">No. client: {client.no_client}</span>
                  </div>
                  <button className="win-btn-action win-btn-select" onClick={() => handleSelectExistingClient(client)} data-testid={`select-client-${index}`}>Sélectionner</button>
                </div>
              ))}
            </div>
            <div className="nouveau-modal-question"><p>Voulez-vous utiliser un client existant ou créer un nouveau dossier?</p></div>
            <div className="nouveau-modal-actions">
              <button className="win-btn-action win-btn-danger" onClick={handleCreateNewAnyway} data-testid="nouveau-creer-quand-meme">Créer un nouveau dossier</button>
              <button className="win-btn-action win-btn-secondary" onClick={() => setShowDuplicateList(false)}>Retour</button>
              <button className="win-btn-action win-btn-secondary" onClick={() => setShowNouveauModal(false)}>Annuler</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NouveauModal;
